<template>
  <nx-content-wizard
      ref="wizard"
      type="image"
      :active="active"
      :config="wizardConfig"
      autoPublishSwitch
      @dismiss="onDismiss"
      @entityCreated="entityCreated"
  >
    <template slot="toolbar" slot-scope="slot">
      <v-btn
          :loading="loading"
          @click="create"
          color="accent"
          dark flat
          :disabled="!slot.validForm || !validUpload || loading"
      >{{ $t('message.wizard.createBtn') }}
      </v-btn>
    </template>
    <template slot-scope="slot">
      <nx-form-text
        name="signatureAuthorName"
        :label="$t('message.form.fields.signatureAuthorName')"
        v-model="slot.draft.signatureAuthorName"
      ></nx-form-text>

      <nx-upload-file
          ref="upload"
          :label="$t('message.wizard.image')"
          name="file"
          :data="slot.creationData"
          :options="options"
          :allowed-mimes="options.accept"
          :before-upload-force-clip="features.FORCE_CLIP_ORIGINAL_IMAGES_BEFORE_UPLOAD"
          :before-upload-automatic-clip="features.AUTOMATIC_CLIP_ORIGINAL_IMAGES_BEFORE_UPLOAD"
          :before-upload-clippings-config="beforeUploadClippingsConfig"
          @newFile="onFileSelected"
          @load="onLoad"
          @success="onSuccess"
      ></nx-upload-file>
    </template>
  </nx-content-wizard>
</template>

<script>
import Wizard from '@/modules/content/wizard/ContentWizard';
import NxUploadFile from '@/modules/upload/UploadFile';
import { imageWizard } from '@/modules/content/config';
import { mapGetters } from 'vuex';
import { getImageAuthor, getImageDescription } from '@/utils/exif';
import isEmpty from 'lodash/isEmpty';

export default {
  name: 'nx-content-image-wizard',
  components: {
    [Wizard.name]: Wizard,
    NxUploadFile,
  },
  props: {
    active: {
      type: Boolean,
    },
    beforeCreateClippingAliases: {
      type: Array,
      default: () => ([]),
    },
  },
  data() {
    return {
      loading: false,
    };
  },
  computed: {
    ...mapGetters(['beforeCreateClippingAspectRatioAliases', 'features']),
    beforeUploadClippingsConfig() {
      if (!this.features.CLIP_ORIGINAL_IMAGES_BEFORE_UPLOAD) {
        return [];
      }
      if (!isEmpty(this.beforeCreateClippingAliases)) {
        return this.beforeCreateClippingAliases;
      }
      return this.beforeCreateClippingAspectRatioAliases;
    },
    options() {
      return {
        maximum: 1,
        paramName: 'file',
        url: '/api/content/image',
        accept: imageWizard.allowedMimes,
        size: 100 * 1000000, // 100 Mb
        focalPointEnabled: this.features.IMAGE_FOCAL_POINT,
      };
    },
    validUpload() {
      return this.$refs.upload.valid && this.$refs.upload.files.length;
    },
    wizardConfig() {
      return this.$store.getters.getWizard('image');
    },
  },
  methods: {
    create() {
      if (this.$refs.upload.valid) {
        this.$refs.upload.submit();
      }
    },
    onDismiss() {
      this.$refs.upload.clear();
      this.$emit('dismiss');
    },
    onLoad(state) {
      this.loading = state;
    },
    async onFileSelected({ file }) {
      const description = await getImageDescription(file);
      const draftTitle = this.$refs.wizard && this.$refs.wizard.draft && this.$refs.wizard.draft.title;
      if (description && !draftTitle) {
        this.$refs.wizard.updateField('title', description);
      }
      const author = await getImageAuthor(file);
      if (author) {
        this.$refs.wizard.updateField('signatureAuthorName', author);
      }
    },
    onSuccess(file) {
      this.$refs.wizard.success(file.response.response);
    },
    entityCreated(entity) {
      this.$emit('entityCreated', entity);
    },
  },
  mounted() {
    this.$refs.wizard.validateForm();
  },
};
</script>
